import i18n from '@/plugins/i18n';
import type { DataTableHeader } from '@/types/vuetify';

export function createWlBalanceTableHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t('wlBalance.platform'),
            value: 'platform',
            key: 'platform',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('wlBalance.betCount'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.betCount'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.playerStake'),
            value: 'settledStakeSum',
            key: 'settledStakeSum',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('wlBalance.playerPl'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('wlBalance.wlToTb'),
            value: 'wlToTb',
            key: 'wlToTb',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.wlToTb'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.a2fFinalOperation'),
            value: 'a2fFinalOperation',
            key: 'a2fFinalOperation',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.a2fFinalOperation'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.tbToBookiesBrl'),
            value: 'tbToBookmakersBrl',
            key: 'tbToBookmakersBrl',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.tbToBookmakers'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.tbToBookiesEur'),
            value: 'tbToBookmakersEuro',
            key: 'tbToBookmakersEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.tbToBookmakers'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.tbFinalOperationBrl'),
            value: 'tbFinalOperationBrl',
            key: 'tbFinalOperationBrl',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.tbFinalOperation'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.tbFinalOperationEur'),
            value: 'tbFinalOperationEuro',
            key: 'tbFinalOperationEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('wlBalance.tooltips.tbFinalOperation'), class: 'nowrap' },
        },
        {
            title: t('wlBalance.tbBookCommissionsEur'),
            value: 'tbBookCommissionsEuro',
            key: 'tbBookCommissionsEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'wl-balance-col-commissions nowrap', 'data-tooltip': t('wlBalance.tooltips.tbBookCommissionsEur') },
            cellProps: { class: 'wl-balance-col-commissions' },
        },
    ];
}
